// extracted by mini-css-extract-plugin
module.exports = {"noInvestments":"DashboardNoInvestment_noInvestments__gwv4y"};